import { Component, OnInit, AfterViewInit } from '@angular/core';
import { TaskComponent } from '@app/_components/task/task/task.component';

@Component({
    selector: 'app-task-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.css'],
    standalone: false
})
export class MaintenanceComponent extends TaskComponent implements OnInit, AfterViewInit
{
	ngOnInit()
	{
		// instantiate the baseClass
		super.ngOnInit();
	}
	ngAfterViewInit()
	{
		// assign the taskType to phone
		this.form1.patchValue({
			taskType: '3'
		});
	}
}
